import { DynamicStandaloneFacebook } from '@/components/Facebook';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorFacebook: LabradorComponent = ({ type, data, meta }) => {
  return (
    <DynamicStandaloneFacebook
      url={data.url}
      options={{
        isVideo: data.isVideo,
      }}
      data-content-index={meta.contentIndex}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorFacebook;
